"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var unsafeRunAsPromise_exports = {};
__export(unsafeRunAsPromise_exports, {
  unsafeRunAsPromise: () => unsafeRunAsPromise
});
module.exports = __toCommonJS(unsafeRunAsPromise_exports);
var import_util = require("@cartographerio/util");
var import_IO = require("./IO.js");
var import_env = require("./env.js");
var import_error = require("./error.js");
async function runIOLike(arg, env) {
  if (arg instanceof import_IO.IO) {
    return runIO(arg, env);
  } else if (arg instanceof Promise) {
    return arg;
  } else {
    return Promise.resolve(arg);
  }
}
async function runIO(io, env) {
  const { dispatch, getState } = env;
  if (io instanceof import_IO.PureIO) {
    return io._value;
  } else if (io instanceof import_IO.FailIO) {
    throw io._error;
  } else if (io instanceof import_IO.DelayIO) {
    const ioLike = io._func(...io._args);
    const result = await runIOLike(ioLike, env);
    return runIOLike(result, env);
  } else if (io instanceof import_IO.CallbackIO) {
    return new Promise(io._func);
  } else if (io instanceof import_IO.FlatMapIO) {
    const first = await runIO(io._first, env);
    const second = await runIO(io._next(first), env);
    return second;
  } else if (io instanceof import_IO.RecoverIO) {
    try {
      const first = await runIO(io._body, env);
      return first;
    } catch (error) {
      const second = await runIO(io._handler(error), env);
      return second;
    }
  } else if (io instanceof import_IO.CleanupIO) {
    try {
      return await runIO(io._body, env);
    } finally {
      await runIO(io._cleanup, env);
    }
  } else if (io instanceof import_IO.SelectIO) {
    return Promise.resolve(io._selector(getState()));
  } else if (io instanceof import_IO.PutIO) {
    return new Promise((resolve, reject) => {
      try {
        dispatch(io._action);
        resolve(void 0);
      } catch (error) {
        reject(error);
      }
    });
  } else if (io instanceof import_IO.SleepIO) {
    return new Promise((resolve, _reject) => {
      setTimeout(() => resolve(void 0), io._millis);
    });
  } else if (io instanceof import_IO.LimitIO) {
    return io._mutex.semaphore.acquire().then((release) => runIO(io._body, env).finally(release));
  } else if (io instanceof import_IO.LimitOrIO) {
    try {
      const release = io._mutex.semaphore.tryAcquire();
      return runIO(io._body, env).finally(release);
    } catch (error) {
      return runIO(io._fallback, env);
    }
  } else if (io instanceof import_IO.SequenceIO) {
    let values;
    switch (io._parallelism) {
      case "Seq": {
        values = [];
        for (const step of io._params) {
          values.push(await runIO(step, env));
        }
        break;
      }
      case "Par": {
        values = await Promise.all(io._params.map((io2) => runIO(io2, env)));
        break;
      }
      default:
        (0, import_util.checkExhausted)(io._parallelism);
    }
    return io._func(values);
  } else if (io instanceof import_IO.IO) {
    throw new Error("Unknown IO subtype: " + (0, import_util.prettyPrintJson)(io));
  } else {
    throw new Error("Not an IO subtype: " + (0, import_util.prettyPrintJson)(io));
  }
}
async function unsafeRunAsPromise(io, env = (0, import_env.defaultEnvironment)()) {
  return await runIO(io.tapError((0, import_error.globalIOErrorReporter)()), env);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  unsafeRunAsPromise
});
//# sourceMappingURL=unsafeRunAsPromise.js.map
